import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AdornedInput from '../AdornedInput/AdornedInput';
import Adornment from '../Adornment/Adornment';
import { IconSearch } from '../Icon/index';
import { SearchBoxMixin } from '../../mixins/components/SearchBoxMixin';
/**
 * A large search input used for landing pages.
 * The component is responsive and will adjust in between mobile and tablet sizes.
 *
 * * Extends [`AdornedInput`](#/Form%20components?id=adornedinput)
 *
 * @since 6.4.0
 */

var SearchBox = /*#__PURE__*/styled(AdornedInput).withConfig({
  displayName: "SearchBox",
  componentId: "c11n-8-64-0__sc-6uapbf-0"
})(["", ""], SearchBoxMixin);
SearchBox.propTypes = {
  /**
   * The `Adornment` for the `SearchBox`. Defaults to a search `Icon`.
   */
  rightAdornment: PropTypes.node
};
SearchBox.defaultProps = {
  rightAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(IconSearch, null))
};
/** @component */

export default SearchBox;
export var StyledSearchBox = SearchBox;